import React from 'react';
import Link from 'components/Link/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './CalculatorCard.scss';
import { getStringToLowerCase } from '../../../../../utils/common';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const CalculatorCard = ({
  name,
  desc,
  url,
  gaCategory,
  imageId = 76150242,
  isArticleshowPage = false,
  ga4Type,
  ga4Category,
  lazyloadImage,
}) => {
  const getGa4EventsByName = secName => {
    switch (secName) {
      case 'PPF Calculator':
        return { category: 'ppf_calculator', label: 'ppf' };
      case 'FD Calculator':
        return { category: 'fd_calculator', label: 'fd' };
      case 'NPS Calculator':
        return { category: 'nps_calculator', label: 'nps' };
      case 'Mutual Fund Calculator':
        return {
          category: 'mutual_fund_calculator',
          label: 'mutual_fund',
        };
      case 'SIP Calculator':
        return { category: 'sip_calculator', label: 'sip' };
      case 'EMI Calculator':
        return {
          category: 'emi_calculator',
          label: 'emi',
        };
      default:
        return {};
    }
  };
  const buttonClickHandler = secName => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'finance_calculator',
      ...getGa4EventsByName(secName),
    });
  };
  return (
    <Link
      className={s.calculator_cardWrapper}
      forceTargetBlank
      to={url}
      data={{
        gaAction: isArticleshowPage ? 'click' : 'click-other-calculators',
        gaLabel: isArticleshowPage ? 'financial-calculator_click' : name,
        gaCategory,
      }}
      ga4Data={
        ga4Type && [
          {
            event: 'user_click',
            type: `${ga4Type}`,
            category: name ? getStringToLowerCase(name) : ga4Category,
          },
        ]
      }
    >
      <div className={s.calculator_card}>
        <div className={s.left_area}>
          <strong className={s.title}>{name}</strong>
          <div className={s.desc}>
            <p>{desc}</p>
          </div>
        </div>
        <div className={s.right_area}>
          <div className={s.img_wrap}>
            <ImageV2
              src={`https://static.toiimg.com/photo/${imageId}.cms`}
              alt={name}
              lazyload={lazyloadImage}
            />
          </div>
        </div>
      </div>
      <span
        onClick={() => {
          buttonClickHandler(name);
        }}
        className={s.calculate_button}
      >
        Calculate Now <i className={s.rightArrow} />
      </span>
    </Link>
  );
};

export default CalculatorCard;
